
    import './styles.scoped.css';
    export default {
  "column-layout": "awsui_column-layout_vj6p7_17mlt_93",
  "grid": "awsui_grid_vj6p7_17mlt_104",
  "grid-no-gutters": "awsui_grid-no-gutters_vj6p7_17mlt_109",
  "grid-variant-text-grid": "awsui_grid-variant-text-grid_vj6p7_17mlt_112",
  "grid-breakpoint-default": "awsui_grid-breakpoint-default_vj6p7_17mlt_119",
  "grid-columns-1": "awsui_grid-columns-1_vj6p7_17mlt_122",
  "grid-breakpoint-xxs": "awsui_grid-breakpoint-xxs_vj6p7_17mlt_122",
  "grid-breakpoint-xs": "awsui_grid-breakpoint-xs_vj6p7_17mlt_125",
  "grid-columns-2": "awsui_grid-columns-2_vj6p7_17mlt_128",
  "grid-columns-3": "awsui_grid-columns-3_vj6p7_17mlt_134",
  "grid-columns-4": "awsui_grid-columns-4_vj6p7_17mlt_140",
  "grid-vertical-borders": "awsui_grid-vertical-borders_vj6p7_17mlt_153",
  "grid-horizontal-borders": "awsui_grid-horizontal-borders_vj6p7_17mlt_186",
  "root": "awsui_root_vj6p7_17mlt_240",
  "tile-container": "awsui_tile-container_vj6p7_17mlt_255",
  "has-metadata": "awsui_has-metadata_vj6p7_17mlt_264",
  "selected": "awsui_selected_vj6p7_17mlt_267",
  "disabled": "awsui_disabled_vj6p7_17mlt_271",
  "columns": "awsui_columns_vj6p7_17mlt_286",
  "column-1": "awsui_column-1_vj6p7_17mlt_291",
  "breakpoint-xs": "awsui_breakpoint-xs_vj6p7_17mlt_298",
  "breakpoint-xxs": "awsui_breakpoint-xxs_vj6p7_17mlt_303",
  "column-2": "awsui_column-2_vj6p7_17mlt_308",
  "column-3": "awsui_column-3_vj6p7_17mlt_325",
  "column-4": "awsui_column-4_vj6p7_17mlt_342",
  "control": "awsui_control_vj6p7_17mlt_360",
  "no-image": "awsui_no-image_vj6p7_17mlt_364",
  "image": "awsui_image_vj6p7_17mlt_368"
};
  